<div class="d-flex justify-content-center align-items-center h-100">
    <dp-sre-gantt-column
        *ngFor="let column of columns; let first = first; let last = last"
        [value]="first ? columns[1] : column"
        [firstValue]="first"
        [class.last]="last"
    ></dp-sre-gantt-column>
</div>
